import React from 'react';
import { Button } from './ui/button';

// Brand SVG icons (inline)
const GoogleIcon = () => (
  <svg className="w-5 h-5" viewBox="0 0 48 48">
    <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.7-6.1 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 8 3l5.7-5.7C34.5 6.1 29.5 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.7-.4-3.5z"/>
    <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.6 16 19 13 24 13c3.1 0 5.8 1.2 8 3l5.7-5.7C34.5 6.1 29.5 4 24 4 16.3 4 9.7 8.4 6.3 14.7z"/>
    <path fill="#4CAF50" d="M24 44c5.4 0 10.3-2.1 14-5.4l-6.5-5.5c-2 1.4-4.6 2.3-7.5 2.3-5.2 0-9.6-3.3-11.3-7.9l-6.5 5C9.6 39.6 16.3 44 24 44z"/>
    <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.7 2.1-2.1 4-3.8 5.3l6.5 5.5C42.6 35 44 29.9 44 24c0-1.3-.1-2.7-.4-3.5z"/>
  </svg>
);

const AppleIcon = () => (
  <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
    <path d="M16.365 1.43c0 1.14-.41 2.21-1.18 3.04-.84.95-2.21 1.69-3.45 1.59-.16-1.16.39-2.34 1.16-3.13.85-.92 2.32-1.61 3.47-1.5zM20.5 17.32c-.55 1.27-.81 1.84-1.52 2.97-.99 1.57-2.39 3.53-4.13 3.55-1.55.02-1.95-1.01-4.05-.99-2.1.01-2.54 1.01-4.09.99-1.74-.02-3.07-1.79-4.06-3.36-2.78-4.39-3.07-9.54-1.36-12.27.99-1.58 2.65-2.6 4.36-2.6 1.7 0 2.78.95 4.19.95 1.37 0 2.2-.95 4.17-.95 1.5 0 3.09.82 4.22 2.24-3.71 2.04-3.11 7.42-.73 9.47z"/>
  </svg>
);

const FacebookIcon = () => (
  <svg className="w-5 h-5" viewBox="0 0 24 24" fill="#1877F2">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
);

const SocialButtons = ({ onSelect }) => {
  // Real Google sign-in via Emergent Auth
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const handleGoogle = () => {
    const redirectUrl = window.location.origin + '/auth/callback';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const providers = [
    { id: 'google', label: 'Continue with Google', Icon: GoogleIcon, handler: handleGoogle, enabled: true },
    { id: 'apple', label: 'Continue with Apple', Icon: AppleIcon, handler: () => onSelect('apple'), enabled: false },
    { id: 'facebook', label: 'Continue with Facebook', Icon: FacebookIcon, handler: () => onSelect('facebook'), enabled: false },
  ];

  return (
    <div className="mt-7 grid grid-cols-1 gap-2">
      {providers.map(p => (
        <Button
          key={p.id}
          type="button"
          variant="outline"
          onClick={p.handler}
          className={`h-11 bg-white border-slate-200 text-slate-700 font-medium rounded-lg justify-center gap-2.5 ${
            p.enabled ? 'hover:bg-slate-50' : 'opacity-60 hover:bg-white'
          }`}
        >
          <p.Icon /> {p.label}
          {!p.enabled && <span className="text-[10px] text-slate-400 font-normal ml-1">(coming soon)</span>}
        </Button>
      ))}
    </div>
  );
};

export default SocialButtons;
